import { getGlobals } from "storyblok/api"
import { getAllArchiveNewsCategories, getAllNewsItemCategoriesPaths, getCategoryArchiveNewsItems } from "storyblok/inTheNews"
import CategoryArchiveSection from "components/Archive/CategoryArchiveSection"
import PageHeader from "components/DynamicComponent/molecules/PageHeader"
import InTheNewsCard from "components/InTheNewsCard"
import Meta from "components/Meta"
import { getCategoryArchiveNewsItemsApi } from "storyblok/inTheNewsApi"
import { CardListSection } from "components/Archive/CardListSection"

export default function InTheNewsArchive({ category, items, categories, perPage, total, currentPage }) {
  return (
    <>
      <Meta info={{ title: `${category.name}`, og_title: `${category.name}`, twitter_title: `${category.name}` }} />
      <PageHeader
        blok={{
          type: "standard",
          heading: category?.name,
          breadcrumbs: [{ text: "In the News", href: "/in-the-news" }, { text: category.name }],
        }}
      />
      <CategoryArchiveSection
        categories={categories}
        archiveLink="/in-the-news"
        categoryLinkPrefix="/in-the-news/category/"
        currentTab={category}
        list={<CardListSection
          key={category.value}
          items={items}
          total={total}
          perPage={perPage}
          currentPage={currentPage}
          columns={3}
          category={category.value}
          handler={(params) => getCategoryArchiveNewsItemsApi(params)}
          Card={InTheNewsCard} />}
      />
    </>
  )
}

export async function getStaticProps({ params: { category } }) {
  const globals = await getGlobals()
  const categories = await getAllArchiveNewsCategories()
  const { items, currentPage, total, perPage } = await getCategoryArchiveNewsItems({ category })

  return {
    props: {
      category: { name: category.replaceAll("-", " "), value: category },
      items: items ?? null,
      perPage,
      total,
      currentPage,
      categories: categories ?? null,
      globals: globals ?? null,
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getAllNewsItemCategoriesPaths(),
    fallback: false,
  }
}
